import React from 'react'

export default function Trends() {
  return (
    <div className="screen-container">
      Trends
    </div>
  )
}
